<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700">
      <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
      </div>
      <Navbar></Navbar>
    </aside>
    
    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Top Navbar -->
       <Header></Header>
      
      <!-- Affiliates Page -->
      <main class="p-6 flex-1">
        <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
        rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
          <h3 class="text-lg font-semibold mb-4">Affiliate Program</h3>
          <p class="text-gray-300 mb-4">Earn commissions by referring new customers to Syniac Cloud. Share your unique referral link and earn rewards for each signup.</p>
          <div class="bg-gray-700 p-4 rounded-lg shadow-inner">
            <p class="text-gray-300 mb-2"><strong>Your Referral Link:</strong></p>
            <div class="flex items-center space-x-2">
              <input type="text" class="w-full p-2 bg-gray-800 rounded-lg text-white" :value="`https://syniac.com/ref/${referralLink}`" readonly>
              <button class="px-4 py-2 bg-blue-500 rounded-lg hover:bg-blue-600" @click="copyReferralLink">Copy</button>
            </div>
          </div>
          <div class="mt-6">
            <h4 class="text-lg font-semibold mb-2">Earnings</h4>
            <div class="bg-gray-700 p-4 rounded-lg shadow-inner">
              <p class="text-gray-300"><strong>Total Referrals:</strong> {{ totalReferrals }}</p>
              <p class="text-gray-300"><strong>Total Earnings:</strong> ${{ totalEarnings }}</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/nav.vue';
import Header from '@/components/header.vue';
import axios from 'axios';

export default {
  name: "CloudAffiliates",
  data() {
    return {
      referralLink: "",
      totalReferrals: 0,
      totalEarnings: 0,
      user: {
      name: '',
      initials: ''
    },
    };
  },
  methods: {
    async fetchAffiliateData() {
      try {
        const response = await axios.get("https://api.syniac.com:3000/api/affiliate/fetch", { withCredentials: true });
        this.referralLink = response.data.rows["0"].affid;
        this.totalReferrals = response.data.rows["0"].affreferrals;
        this.totalEarnings = response.data.rows["0"].affearnings;
      } catch (error) {
        console.error("Error fetching affiliate data:", error);
      }
    },
    copyReferralLink() {
      navigator.clipboard.writeText(this.referralLink).then(() => {
        alert("Referral link copied to clipboard!");
      });
    },
  },
  created() {
    this.fetchAffiliateData();
  },
  components: {
    Navbar,
    Header
  }
};
</script>
